import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-search-update-confirmation',
  templateUrl: './search-update-confirmation.component.html',
  styleUrls: ['./search-update-confirmation.component.scss']
})
export class SearchUpdateConfirmationComponent implements OnInit {

  
  @Input() public title: string = 'Confirmation';
  @Input() public okBtnLabel: string = 'OK';
  @Input() public cancelBtnLabel: string = 'Cancel';
  @Input() public isExceptionModal: boolean = true;

  @Input() public customClass:string='';

  @Output() onConfirm = new EventEmitter<any>();
  @Output() onCancel = new EventEmitter<any>();

  public displayModal: boolean = false;
  public message: string= '';
  public isCancelBtnVisible: boolean = true;
  assetsUrl = '';
  constructor() {
    //do nothing
   }

  ngOnInit(): void {
    this.assetsUrl = environment.assetsUrl;
  }


  public showModal(message: any, cancelBtnVisible: boolean = true): void {
    this.message = message;
    this.isCancelBtnVisible = cancelBtnVisible;
    this.displayModal = true;
  }


  public cancel(): void {
    this.displayModal = false;
    this.onCancel.emit(null);
  }


  public confirm(): void {
    this.displayModal = false;
    this.onConfirm.emit(null);
  }

}
